export default {
  list: [
    {
      title: 'عادی',
      value: 'NORMAL'
    },
    {
      title: 'بالای 5 نفر',
      value: 'MORE_THAN_FIVE'
    },
  ],
  values: {
    NORMAL: 'NORMAL',
    MORE_THAN_FIVE: 'MORE_THAN_FIVE',
  }
}